import { useMutation } from "@tanstack/react-query";
import { APIErrorResponse } from "src/types/generic";
import apiFastifyClient from "../apiFastifyCloud";
import { IEmployeeBodyData } from "src/types/employees";

export const useAddEmployeeMutation = () =>
  useMutation<any, APIErrorResponse, IEmployeeBodyData>({
    mutationFn: async (data) => {
      return apiFastifyClient.post(`/v1/employees`, data);
    },
  });

export const useUpdateEmployeeMutation = () =>
  useMutation<any, APIErrorResponse, IEmployeeBodyData>({
    mutationFn: async (data) => {
      return apiFastifyClient.put(`/v1/employees`, data);
    },
  });

export const useArchiveEmployeeMutation = () =>
  useMutation<any, APIErrorResponse, string>({
    mutationFn: async (employeeId) => {
      return apiFastifyClient.put(`/v1/employees/archive`, { employeeId });
    },
  });

export const useActivateEmployeeMutation = () =>
  useMutation<any, APIErrorResponse, string>({
    mutationFn: async (employeeId) => {
      return apiFastifyClient.put(`/v1/employees/unarchive`, { employeeId });
    },
  });
